import { createStore } from 'redux';
import baseStateReducer from './reducers/base_state_reducer.js';

const store = createStore(baseStateReducer);

export default store;
